/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="97.47"
        height="95.59"
        viewBox="0 0 97.47 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M83.06 3a1.26 1.26 0 0 1 1.25 1.12v34.22a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.09v-33H71.15v10a1.26 1.26 0 0 1-1.12 1.25h-.09a1.26 1.26 0 0 1-1.24-1.12V4.28a1.26 1.26 0 0 1 1.12-1.26ZM14.35 24a1.26 1.26 0 0 1 1.25 1.12V78h33.41a1.26 1.26 0 0 1 1.25 1.12v.16a1.23 1.23 0 0 1-1.12 1.24H14.35a1.26 1.26 0 0 1-1.24-1.12V25.22A1.25 1.25 0 0 1 14.35 24Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M47.99.22a1.23 1.23 0 0 1 1.29-.07l.12.07 47.46 32.49a1.252 1.252 0 0 1-1.3 2.14l-.11-.07-46.75-32-46.76 32a1.26 1.26 0 0 1-1.66-.22l-.08-.11a1.25 1.25 0 0 1 .22-1.65l.1-.09ZM91.08 56.28a1.23 1.23 0 0 1 1.24 1.12v35.93a1.29 1.29 0 0 1-.57 1l-.12.07-2 1a1.24 1.24 0 0 1-1 .06l-.13-.06-3.47-1.73-3.47 1.73a1.24 1.24 0 0 1-1 .06l-.13-.06-3.49-1.73-3.47 1.78a1.24 1.24 0 0 1-1 .06l-.14-.06-3.47-1.73-3.39 1.73a1.24 1.24 0 0 1-1 .06l-.13-.06-3.4-1.73-3.47 1.73a1.24 1.24 0 0 1-1 .06l-.14-.06-2-1a1.3 1.3 0 0 1-.68-1V57.53a1.27 1.27 0 0 1 1.28-1.23 1.25 1.25 0 0 1 1.21 1.1v35.15l.76.39 3.47-1.74a1.29 1.29 0 0 1 1-.06l.13.06 3.47 1.74 3.47-1.74a1.25 1.25 0 0 1 1-.06l.13.06 3.47 1.74 3.47-1.74a1.25 1.25 0 0 1 1-.06l.14.06 3.46 1.74 3.43-1.74a1.29 1.29 0 0 1 1-.06l.13.06 3.47 1.74.76-.39v-35a1.27 1.27 0 0 1 1.04-1.27Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M91.08 42.92A1.23 1.23 0 0 1 92.32 44v13.53a1.25 1.25 0 0 1-2.49.12V45.42H56.09v12.11a1.25 1.25 0 0 1-1.12 1.24h-.13a1.26 1.26 0 0 1-1.24-1.13V44.17a1.27 1.27 0 0 1 1.12-1.25h36.36Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M71.49 53.47v2.65l-.41.08-.41.08a6.35 6.35 0 0 0-4.79 3.89 8 8 0 0 0-.55 3.62 6.24 6.24 0 0 0 3.32 5.29 28.89 28.89 0 0 0 2.79 1.2c1.16.49 2.35.94 3.51 1.44a2.11 2.11 0 0 1 1.32 2.31 2.3 2.3 0 0 1-1.86 2.32 6.56 6.56 0 0 1-1.47.16 3.65 3.65 0 0 1-3.73-2.73c-.11-.32-.19-.66-.29-1l-4.43 1.18a9.36 9.36 0 0 0 2.14 4.4 7.55 7.55 0 0 0 4.88 2.24v3.36h2.87v-3.41c.57-.11 1.14-.2 1.68-.34a6.65 6.65 0 0 0 4.68-3.8 7.6 7.6 0 0 0 .53-4.63 6.08 6.08 0 0 0-3.1-4.41 34.12 34.12 0 0 0-4.25-1.85c-.87-.35-1.72-.75-2.56-1.16a1.92 1.92 0 0 1-1-1.16 2.62 2.62 0 0 1 1.79-3.22h.08a3 3 0 0 1 3 .78 5.51 5.51 0 0 1 1.21 1.83l.28.67 4-1.65a7.84 7.84 0 0 0-1.46-3 7 7 0 0 0-4.83-2.52v-2.64Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'HouseWithPaperMoneyIcon';

export default Icon;
